
import { columns } from './constants'
// import { store } from '../../../store/configureStore'

export function validateIpAddress(oldOnValueChanged) {
  return args => {
    let value = args.value;
    if (value !== '' && !value) return

    const filtersForWhichValidate =
      ['equals', 'not-equals', 'less', 'less-equal', 'greater', 'greater-equal', 'default']
    const isUseValidation = filtersForWhichValidate.some(filter => args.element.parentElement.parentElement.firstChild
      .firstChild.firstChild.firstChild.firstChild.firstChild.firstChild.classList.value.indexOf(filter) !== -1)

    if (isUseValidation) {
      const isValid = (/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/).test(value) || value === ''
      if (!isValid) {
        args.element.classList.add('dx-invalid')
        return
      }
    }

    args.element.classList.remove('dx-invalid');
    oldOnValueChanged(args);
  }
}

export function getCurrentDateForPlaceholder() {
  const dateObj = new Date();
  const month = dateObj.getUTCMonth() + 1;
  const day = dateObj.getUTCDate();
  const year = dateObj.getUTCFullYear();
  return `${day}/${month}/${year}`
}

export function onKeyDown(dataGridRef, setFocusedRowKey) {
  return dataGridEvent => {
    const event = dataGridEvent.event
    // const totalCount = store.getState().transcriptViewer.totalCount

    // console.warn('dataGridEvent', dataGridEvent)

    // if (event.code === 'ArrowUp') {
    //   const selectedRowKey = dataGridRef.current.instance.getSelectedRowKeys()[0]
    //   const selectedRowIndex = dataGridRef.current.instance.getRowIndexByKey(selectedRowKey)
    //   if (selectedRowIndex === 0) return
    //   dataGridRef.current.instance.selectRowsByIndexes(selectedRowIndex - 1)
    // } else if (event.code === 'ArrowDown') {
    //   const selectedRowKey = dataGridRef.current.instance.getSelectedRowKeys()[0]
    //   const selectedRowIndex = dataGridRef.current.instance.getRowIndexByKey(selectedRowKey)
    //   if (selectedRowIndex + 1 === totalCount) return
    //   dataGridRef.current.instance.selectRowsByIndexes(selectedRowIndex + 1)
    // } else
    if (event.code === 'Home' && event.originalEvent.ctrlKey) { /* scroll top */
      dataGridRef.current.instance.getScrollable().scrollTo(0)
      // dataGridRef.current.instance.selectRowsByIndexes(0)
      // setFocusedRowKey(0)
      // dataGridEvent.component.option('focusedRowIndex', 0);
    } else if (event.code === 'End' && event.originalEvent.ctrlKey) { /* scroll bottom */
      const scrollHeight = dataGridRef.current.instance.getScrollable().scrollHeight()
      dataGridRef.current.instance.getScrollable().scrollTo(scrollHeight)
      // dataGridRef.current.instance.selectRowsByIndexes(totalCount - 1)
      // setFocusedRowKey(totalCount - 1)
      // dataGridEvent.component.option('focusedRowIndex', totalCount - 1);
    }
  }
}

export function isNotEmpty(value) {
  return value !== undefined && value !== null && value !== '';
}

// export function calculateOperatorsNickname(dataS) {
//   if (!dataS.operators) return ''

//   let agents = [];
//   dataS.operators.forEach(operator => agents.push(operator.nickname));
//   return agents.join(', ');
// }

function getColumnDataType(dataField) {
  if (dataField === 'chatDuration') return 'number'
  if (dataField === 'transcriptId') return 'string'
  const column = columns().find(columnParams => columnParams.dataField === dataField)
  return column.dataType
}
function isValueMatchesFilters(selectedTranscript, filter) {
  let [paramKeys, logicalOperator, filterValue] = filter
  const dataType = getColumnDataType(paramKeys)
  paramKeys = paramKeys.split('.')

  let transcriptParam = selectedTranscript;
  paramKeys.forEach(paramKey => transcriptParam = transcriptParam[paramKey])

  if (dataType === 'string') {
    transcriptParam = transcriptParam ? transcriptParam.toLowerCase() : ''
    filterValue = filterValue ? filterValue.toLowerCase() : ''
    if (
      (logicalOperator === 'contains' && transcriptParam.indexOf(filterValue) !== -1)
      ||
      (logicalOperator === 'notcontains' && transcriptParam.indexOf(filterValue) === -1)
      ||
      (logicalOperator === 'startswith' && transcriptParam.indexOf(filterValue) === 0)
      ||
      (logicalOperator === 'endswith'
        && transcriptParam.indexOf(filterValue) === (transcriptParam.length - filterValue.length))
      ||
      (logicalOperator === '=' && transcriptParam === filterValue)
      ||
      (logicalOperator === '<>' && transcriptParam !== filterValue)
    ) {
      return true
    }
  } else if (dataType === 'number' || dataType === 'date') {
    if (
      (logicalOperator === '=' && transcriptParam === filterValue)
      ||
      (logicalOperator === '<>' && transcriptParam !== filterValue)
      ||
      (logicalOperator === '<' && transcriptParam < filterValue)
      ||
      (logicalOperator === '>' && transcriptParam > filterValue)
      ||
      (logicalOperator === '<=' && transcriptParam <= filterValue)
      ||
      (logicalOperator === '>=' && transcriptParam >= filterValue)
      ||
      (logicalOperator === 'between' && transcriptParam > filterValue[0] && transcriptParam < filterValue[1])
    ) {
      return true
    }
  }
  return false
}
export function isNeedShowSelectedTranscript(selectedTranscript, filters) {
  if (!filters) return true
  if (typeof filters[0] === 'string') {
    if (filters[0] === '!') {
      return !isValueMatchesFilters(selectedTranscript, filters[1])
    }
    return isValueMatchesFilters(selectedTranscript, filters)
  }
  if (Array.isArray(filters[0])) {
    for (let ii = 0; ii < filters.length; ii += 2) {
      if (!isNeedShowSelectedTranscript(selectedTranscript, filters[ii])) return false
    }
  }
  return true
}

function createMenuItem({ text, icon, cssClass, onClick }, ii) {
  const wrapper = document.createElement('p')
  wrapper.innerHTML = `
    <div
      class="dx-item dx-list-item index-${ii} ${cssClass}"
      role="option"
      id="dx-126da892-ffa4-288e-fb7d-34080a5901a${ii}"
    >
      <div class="dx-item-content dx-list-item-content">
        <div class="dx-list-item-icon-container">
          <i class="dx-icon dx-icon-${icon} dx-list-item-icon"></i>
        </div>
        ${text}
      </div>
    </div>`
  const children = wrapper.children[0]
  // children.onClick = onClick
  children.addEventListener('click', onClick, false)
  return children
}
export function createMenuItems(data, _ignore, container) {
  if (!container) {
    container = document.createElement('div')
  }

  const items = data.options ? data.options.items : data
  items.forEach((item, ii) => {
    container.appendChild(createMenuItem(item, ii))
  })
  return container
}

export function createMenuItemsForDropDownButton(items) {
  let wrapper = document.createElement('div');
  items.forEach((item, ii) => {
    wrapper.appendChild(createMenuItem(item, ii))
  });
  return wrapper
}

let isColumChoserOpen = false
export function switchColumChoser(dataGridRef) {
  return () => {
    if (isColumChoserOpen) {
      dataGridRef.current.instance.hideColumnChooser()
    } else {
      dataGridRef.current.instance.showColumnChooser()
    }
    isColumChoserOpen = !isColumChoserOpen
  }
}
